import { InputTextField } from '@lastbrand/web-ui/input-text-field'
import { useTranslation } from 'next-i18next'
import React, { useCallback, useState } from 'react'

import { OptionProp } from '@src/quince-site-pdp/src/atoms/optionSelector/OptionSelector.constant'

import { inputFieldCss, inputOptionWrapperClass } from './input-option-ds.styles'

const REGEX_PATTERN = /^[A-Za-z]*$/

// Engraving field via `@lastbrand/web-ui/input-text-field` — its built-in `error`
// slot surfaces both server-side and client validation errors.
const InputOptionDS = ({
  onChange,
  maxCharacterLimit,
  minCharacterLimit,
  inputOptionError,
}: Pick<OptionProp, 'onChange' | 'maxCharacterLimit' | 'minCharacterLimit' | 'inputOptionError'>) => {
  const { t } = useTranslation('common')
  const [inputText, setInputText] = useState('')
  const [errorText, setErrorText] = useState<string | null>(null)

  const placeholderText =
    maxCharacterLimit === minCharacterLimit
      ? t('enter_var1_characters', { var1: minCharacterLimit })
      : t('enter_up_to_var1_characters', { var1: maxCharacterLimit })

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value
      const isValidText = REGEX_PATTERN.test(value)

      // Capitalize all letters if minCharacterLimit === maxCharacterLimit
      if (minCharacterLimit === maxCharacterLimit) {
        value = value.toUpperCase()
      } else value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      if (value.length === 0) setErrorText(null)
      if (value.length > 0) {
        if (!isValidText) {
          setErrorText(t('only_letters_allowed'))
        } else if (maxCharacterLimit && value.length > maxCharacterLimit) {
          setErrorText(t('maximum_characters_var1_allowed', { var1: maxCharacterLimit }))
        } else setErrorText(null)
      }
      setInputText(value)
      onChange?.(value)
    },
    [onChange, maxCharacterLimit, minCharacterLimit, t],
  )

  const displayError = inputOptionError || errorText

  return (
    <div className={inputOptionWrapperClass}>
      <InputTextField
        css={inputFieldCss}
        placeholder={placeholderText}
        aria-label={placeholderText}
        value={inputText}
        error={displayError ?? undefined}
        onChange={handleChange}
      />
    </div>
  )
}

const InputOptionDSWithOptionValue = ({ optionValue: _optionValue, ...props }: OptionProp) => {
  return (
    <InputOptionDS
      onChange={props.onChange}
      maxCharacterLimit={props.maxCharacterLimit}
      minCharacterLimit={props.minCharacterLimit}
      inputOptionError={props.inputOptionError}
    />
  )
}

export default InputOptionDSWithOptionValue
